import React, { Fragment, useEffect, useState } from 'react';

import CardBody from 'components/Card/CardBody.js';
import CardFooter from 'components/Card/CardFooter.js';
import ExportTableExcel from 'components/Tvendo/Common/ExportTable';

import { calcTotal } from './calculatorGroups.js';
import { currency } from 'hooks/Pipe';

import { wsGet } from 'services/WService.js';
import {
  styleTable,
  bgMarino,
  bgOrange,
  bgAqua,
  bgFooter,
  bgBlue,
  bgYellow
} from '../../../Tableconstants/tableConstans.js';

const groupsArticles = [
  { type: 'M', label: 'MASIVO' },
  { type: 'F', label: 'EXTRAS - PROD. FOCO' }
];

export default function Incentive(props) {
  const { idIncentive } = props;

  const [incentive, setIncentive] = useState({});
  const [calcIncentives, setCalcIncentives] = useState([]);
  const [bossReward, setBossReward] = useState({});

  async function showIncentive() {
    let response = await wsGet('com/incentive', idIncentive);
    if (response.success) {
      setIncentive(response.data);
      const dataCalc = calcTotal(response.data.providers);
      setCalcIncentives(dataCalc.totalGroups);
      setBossReward(dataCalc.bossReward);
    }
  }
  useEffect(() => {
    showIncentive();
  }, []);

  return (
    <Fragment>
      <CardBody>
        <div style={{ overflow: 'auto' }}>
          {calcIncentives.length > 0 ? (
            <table
              id="table-incentive"
              border="1"
              width="100%"
              cellPadding="2"
              cellSpacing="0"
              style={styleTable}
            >
              <thead>
                <tr>
                  <th rowSpan="2" style={bgBlue}>
                    {`${incentive.description || ''} ${
                      ' - ' + incentive.base_zone_description || ''
                    } (${incentive.period})`}
                  </th>
                  {incentive.canals.map((item, i) => (
                    <th key={i} colSpan="2" style={bgMarino}>
                      {`${item.base_canal_description || ''} (${currency(
                        item.seller_reward || 0
                      )})`}
                    </th>
                  ))}
                </tr>
                <tr>
                  <th colSpan="2" style={bgOrange}>
                    Mixta
                  </th>
                  <th colSpan="2" style={bgOrange}>
                    Mixta
                  </th>
                </tr>
              </thead>
              <tbody>
                {groupsArticles?.map((group, i) => {
                  return (
                    <SubHeader
                      key={i}
                      typeGroup={group}
                      details={incentive.providers?.filter(
                        (item) => item.incentive_type === group.type
                      )}
                      totalRow={calcIncentives?.filter(
                        (item) => item.incentive_type === group.type
                      )}
                    />
                  );
                })}

                <tr>
                  <th colSpan="5" style={bgMarino}>
                    Premio de supervisor (SSVV)
                  </th>
                </tr>
                <tr>
                  <th style={bgAqua}>PROVEEDORES</th>
                  <th style={bgAqua}>PESO</th>
                  <th style={bgAqua}>PREMIO</th>
                  <th colSpan="2" style={bgAqua}>
                    OBSERVACIONES
                  </th>
                </tr>
                <SupervisorRewards incentive={incentive} />
                <BossRewards data={bossReward} />
              </tbody>
            </table>
          ) : (
            <h5>
              <b>Nota:</b> Los detalles de este documento estan incompletos
            </h5>
          )}
        </div>
      </CardBody>
      {calcIncentives.length === 0 ? undefined : (
        <CardFooter>
          <ExportTableExcel nameFile="Incentivos" idTable="table-incentive" />
        </CardFooter>
      )}
    </Fragment>
  );
}

function SubHeader({ typeGroup, details, totalRow }) {
  return (
    <>
      <tr>
        <th rowSpan="2" style={bgYellow}>
          GRUPO
        </th>
        <th style={bgAqua} colSpan="2">
          {typeGroup.label}
        </th>
        <th style={bgAqua} colSpan="2">
          {typeGroup.label}
        </th>
      </tr>
      <tr>
        {totalRow.map((item, i) => (
          <th key={i} style={bgYellow}>
            {item.indicator_type === 'V'
              ? 'PREMIO VOLUMEN'
              : item.indicator_type === 'C'
              ? 'PREMIO COBERTURA'
              : 'OTRO'}
          </th>
        ))}
      </tr>

      <Groups data={details} />

      <tr>
        <td style={bgFooter}>Total grupos</td>
        {totalRow.map((item, i) => (
          <td key={i} style={bgFooter}>
            {currency(item.reward, 'xls')}
          </td>
        ))}
      </tr>
      <tr>
        <td height="15px" colSpan="5"></td>
      </tr>
    </>
  );
}

function Groups({ data }) {
  return data.map((prov, i) => (
    <Fragment key={i}>
      <tr>
        <td colSpan="5" align="center">
          <b>{prov.CardName}</b>
        </td>
      </tr>
      {prov.categories.map((cat, key) => {
        return (
          <tr key={key}>
            <td>
              <b>{cat.item_description}</b>
            </td>
            {cat.rewards.map((rew, i) => (
              <td key={i} align="right">
                {currency(rew.reward, 'xls')}
              </td>
            ))}
          </tr>
        );
      })}
    </Fragment>
  ));
}

function SupervisorRewards({ incentive }) {
  return incentive.providers.map((item, i) => (
    <tr key={i}>
      <td>{item.CardName}</td>
      <td style={{ textAlign: 'right' }}>{item.percentage_weight}%</td>
      {i === 0 ? (
        <td
          rowSpan={incentive.providers?.length}
          align="center"
          style={{ backgroundColor: '#FFE699' }}
        >
          {currency(incentive.supervisor_reward, 'xls')}
        </td>
      ) : undefined}
      <td colSpan="2">
        Porcentajes fluctúan entre {item.min_range}% y {item.max_range}%
      </td>
    </tr>
  ));
}

function BossRewards({ data }) {
  return (
    <>
      <tr>
        <td height="15px" colSpan="5"></td>
      </tr>
      <tr>
        <th colSpan="5" style={bgMarino}>
          JEFE DE VENTAS SEDE
        </th>
      </tr>
      {data?.categories?.map((item, i) => (
        <tr key={i}>
          {i === 0 ? (
            <>
              <td rowSpan={data?.categories?.length} align="center">
                Táctico
              </td>
              <td rowSpan={data?.categories?.length} align="center">
                SELL OUT
              </td>
            </>
          ) : undefined}
          <td colSpan="2">{item.item_description}</td>
          <td align="right">{currency(item.boss_reward, 'xls')}</td>
        </tr>
      ))}
    </>
  );
}
